import React, { useState, useRef, useEffect } from "react";
import Select, { components } from "react-select";
import { Form } from "react-bootstrap";

const Option = (props) => {
  return (
    <components.Option {...props}>
      <Form.Check
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        label={props.label}
        id={`checkbox-${props.value}`}
      />
    </components.Option>
  );
};

const CustomValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue, selectProps } = props;
  const selectedCount = getValue().length;

  if (!hasValue) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  }

  const label = selectProps.label || 'item';
  const pluralizedLabel = selectedCount === 1 ? label : (selectProps.pluralLabel || `${label}s`);
  const displayValue = `${selectedCount} ${pluralizedLabel} selected`;

  const inputComponent = React.Children.toArray(children).find(
    (child) =>
      React.isValidElement(child) &&
      child.props.className &&
      child.props.className.includes('input')
  );

  return (
    <components.ValueContainer {...props}>
      <div style={{
        padding: "2px 8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "calc(100% - 15px)"
      }}>
        {displayValue}
      </div>
      {inputComponent}
    </components.ValueContainer>
  );
};

const CustomSelect = (props) => {
  const { isMulti, className, ...rest } = props;
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuIsOpen && containerRef.current && !containerRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuIsOpen]);

  if (isMulti) {
    return (
      <div ref={containerRef} className={className}>
        <Select
          {...rest}
          components={{
            ...props.components,
            Option,
            ValueContainer: CustomValueContainer,
          }}
          isMulti
          isClearable={true}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={{
            control: (base) => ({
              ...base,
              height: '38px',
              minHeight: '38px',
            }),
            valueContainer: (base) => ({
              ...base,
              flexWrap: 'nowrap',
              height: '100%',
            }),
            multiValue: () => ({
              display: 'none',
            }),
            input: (base) => ({
              ...base,
              margin: 0,
              padding: 0,
            }),
          }}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
        />
      </div>
    );
  }

  return <Select {...props} />;
};

export default CustomSelect;